import { Department } from 'server/shared/models/department';
import { Invitee } from 'server/shared/models/invitee';
import { PoolerUser } from 'server/shared/models/user';

/**
 * True when the pooler has no customerInformation departmentIds entry for the target
 * station. Mirrors the department branch of canBookInviteeForJob (excludes external invitees).
 */
function userHasJobDepartmentAssignedForDepartment(
  inviteeUser: PoolerUser,
  departmentId: string,
): boolean {
  if (
    !inviteeUser.customerInformation ||
    !Object.keys(inviteeUser.customerInformation).length
  ) {
    return false;
  }
  return Object.keys(inviteeUser.customerInformation).some((key) =>
    inviteeUser.customerInformation?.[key].departmentIds?.includes(
      departmentId,
    ),
  );
}

export function shouldWarnPoolerNotOnTargetDepartmentForTransfer(
  pooler: PoolerUser | undefined,
  targetDepartment: Department,
  sourceJobInvitee: Invitee | undefined,
): boolean {
  if (!pooler || !sourceJobInvitee) {
    return false;
  }
  if (sourceJobInvitee.customer.isExternal) {
    return false;
  }
  if (pooler.userPreferenceDepartmentBlacklist?.includes(targetDepartment.id)) {
    return true;
  }
  if (userHasJobDepartmentAssignedForDepartment(pooler, targetDepartment.id)) {
    return false;
  }
  return true;
}
